import React from 'react';

function SwitchSmall({
 //   label,
    value,
    onChange
                     }:{
    value: boolean,
    onChange: (val:boolean)=>void,
//    label?: string
}) {
    return <input type="checkbox" className="toggle" checked={value} onChange={(e)=>onChange(e.target.checked)}/>
//    return <Switch checked={value} onChange={(e)=>onChange(e.target.checked)} />
    // return (
    //     <div className="form-switch">
    //         <input
    //             checked={value}
    //             onChange={(e)=>onChange(e.target.checked)}
    //             className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault"/>
    //         {
    //             label ?
    //             <label className="form-check-label" htmlFor="flexSwitchCheckDefault">{label}</label> : null
    //         }
    //     </div>
    // );
}

export default SwitchSmall;
